import api from "./api";

const askQuestion = (data) => {
  return api.post("/chat/ask-question", data);
};

const askUserQuestion = (data) => {
  return api.post("/chat/ask-user-question", data);
};

const chatHistory = (id) => {
  return api.get("/chat-history/" + id);
};

const userChatHistory = (ids) => {
  var documentIds = ids.join(",");
  return api.get("/user-chat-history?documentIds=" + documentIds);
};

export default {
  askQuestion,
  askUserQuestion,
  chatHistory,
  userChatHistory,
};
